export default __webpack_public_path__ + "static/mob-img07-6f5869399b7923250b6b63241545887d.png";